import React from "react";
import { ViewPartnerData } from "../components/view-data/ViewPartnerData";

const ViewPartnerDatas = () => {
  return <ViewPartnerData />;
};

export default ViewPartnerDatas;
